
import {FC} from 'react';
import {SuccessPage} from "./SuccessPage";

export const UpdateSuccessPage: FC = () => {
    return (<SuccessPage isUpdate={true} />)
}
